module.exports = __webpack_public_path__ + "static/media/mina.794a3247.png";